import React from 'react';

export default function RecipeGridLoader() {
  return (
    <div className="loader-container">
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-2 sm:gap-x-3 gap-y-4">
        {[...Array(8)].map((_, index) => (
          <div
            key={index}
            className="bg-white rounded-lg overflow-hidden cursor-pointer"
          >
            {/* Image Placeholder */}
            <div className="w-full h-40 sm:h-48 md:h-64 bg-gray-300 rounded-lg skeleton" />

            {/* Text Placeholders */}
            <div className="py-3 space-y-2">
              <div className="h-4 bg-gray-300 rounded w-3/4 skeleton" />
              <div className="h-4 bg-gray-300 rounded w-1/2 skeleton" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
